import axios from 'axios';
import { getItem } from '@/utils/cookie.js';

export default function(url, file) {
  let formData = new FormData();
  formData.append('file', file);
  return new Promise((resolve, reject) => {
    axios
      .post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Tenant-Id': 'cml-main-service',
          'X-Session-Id': getItem('sessionId') || localStorage.getItem('sessionId'),
        }
      })
      .then(({ data }) => {
        resolve({
          success: '1',
          name: file.name,
          src: data.data,
        });
      })
      .catch(err => {
        reject({ success: '0', err: err });
      });
  });
}
